import { useTheme } from "@/context/ThemeContext";
import DualPaneView from "../components/DualPaneView";
import { cardDataMap } from "../data";
import ExperienceShell from "../ExperienceShell";

export default function TarotExperiencePage() {
  const { effectiveTheme } = useTheme();

  return (
    <ExperienceShell activeId="tarot" contentKey="tarot" contentMode="tarot">
      <DualPaneView data={cardDataMap.tarot} isLight={effectiveTheme === "light"} />
    </ExperienceShell>
  );
}
